<div [formGroup]="form()">
  <ci-text-field-outlined 
    type="textarea"
    [label]="'Información adicional' | translate"
    [placeholder]="'Información adicional' | translate"
    (input)="handleInput($event)"
  ></ci-text-field-outlined>
</div>